import { render } from "./create-parent.vue?vue&type=template&id=6071e8e5&ts=true"
import script from "./create-parent.vue?vue&type=script&lang=ts"
export * from "./create-parent.vue?vue&type=script&lang=ts"

import "./create-parent.vue?vue&type=style&index=0&id=6071e8e5&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__